import { Flex, Text } from "@mantine/core"
import React from "react"
import { useFormContext } from "react-hook-form"

import { Switch } from "@/components/Controlled"
import { SectionTitle } from "@/components/SectionTitle/SectionTitle"
import { getNameFieldForMAChild } from "@/pages/campaign-form/helpers"
import { Icon } from "@/components/Icon/Icon"

interface MessageSettingsFormProps {
    hideAdvocatesChooseWhoToCommunicateWith?: boolean
}

export const advocatesRequireApprovalField = "require_confirmation"
export const advocatesChooseWhoTheyCommunicateWithField = "supporters_can_choose_targets"

export const MessageSettingsForm = ({ hideAdvocatesChooseWhoToCommunicateWith }: MessageSettingsFormProps) => {
    const formContext = useFormContext()
    const shouldReworkWithAI = formContext.watch("should_rework_with_ai")

    return (
        <>
            <SectionTitle title="Message Settings" />
            <Flex direction="column" gap={8}>
                <Switch
                    name={advocatesRequireApprovalField}
                    disabled={shouldReworkWithAI}
                    label="Require approval for all messages"
                />
                {shouldReworkWithAI && (
                    <Flex align="center" gap="xs">
                        <Icon icon="exclamation-triangle" iconFamily="far" color="orange" size="sm" />
                        <Text size="sm">Messages reworked with AI will always require approval</Text>
                    </Flex>
                )}
            </Flex>
            {!hideAdvocatesChooseWhoToCommunicateWith && (
                <Switch
                    name={getNameFieldForMAChild(
                        formContext,
                        DjangIO.app.grassroots.campaign.types.CampaignType.write_member.value,
                        advocatesChooseWhoTheyCommunicateWithField,
                    )}
                    label="Advocates choose who they communicate with"
                />
            )}
        </>
    )
}
export default MessageSettingsForm
